import { Key } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import Video from 'react-scale/components/elements/video';
import rehypeRaw from 'rehype-raw';

import { AnchorArrow } from 'react-scale/components';
import ReactMarkdown from 'react-markdown';

import styles from './features-vertical.module.css';

const FeaturesVertical = ({ features }) => (
  <>
    {features.map(feature => (
      <div
        className={cn(
          'flex flex-col lg:items-center mb-16 lg:mb-0 gap-8 xl:gap-12 lg:pb-20 xl:pb-36 last:pb-0 lg:flex-row'
        )}
      >
        <div className="relative flex xl:flex-shrink-0">
          {feature.useVideo ? (
            <div className="w-full h-full overflow-hidden rounded-2xl">
              <Video
                // @ts-ignore: Unreachable code error
                url={feature.video?.src}
                width={feature.video?.width}
                height={feature.video?.height}
                loop={feature.video?.loop}
                playing={feature.video?.autoplay}
                playsinline={feature.video?.autoplay}
                controls={feature.video?.controls}
                poster={feature.video?.poster}
                muted={feature.video?.muted}
                blackButton
                smallButton
              />
            </div>
          ) : (
            <Image
              className="overflow-hidden rounded-2xl min-w-full"
              src={feature.image?.src}
              alt={feature.image?.alt}
              quality={100}
              width={feature.image?.width}
              height={feature.image?.height}
            />
          )}
        </div>
        <div className="w-full mt-6 sm:mt-10 lg:mt-0">
          <div>
            {feature.icon && (
              <div>
                <Image src={feature.icon.src} width={56} height={56} alt={feature.icon.alt} />
              </div>
            )}
            {feature.overtitle && (
              <span
                className={cn(
                  feature.gradient ? 'text-gradient' : 'text-neutral-400',
                  'inline-block my-4 text-overtitle-sm'
                )}
              >
                {feature.overtitle}
              </span>
            )}
            {feature.text?.map(
              (
                block: {
                  title: string;
                  description: string;
                  link: { name: string; href: any };
                  bullets: any[];
                },
                index
              ) => (
                <div
                  key={index}
                  className={cn({
                    'border-b border-codGray mb-6 xl:mb-8 last:border-none': feature.overtitle
                  })}
                >
                  {block.title !== '' && (
                    <h2 className="text-xl text-white font-aeonik lg:mb-4">{block.title}</h2>
                  )}
                  {block.description !== '' && (
                    <ReactMarkdown
                      rehypePlugins={[rehypeRaw]}
                      className="pb-6 text-base xl:pb-8 text-neutral-400"
                    >
                      {block.description}
                    </ReactMarkdown>
                  )}
                  {block.bullets?.length > 0 && block.bullets && (
                    <ul className="space-y-6">
                      {block.bullets?.map((bullet: { title: string; text: string }, index: Key) => (
                        <li key={index} className="flex items-start space-x-4 text-base">
                          <picture
                            className={cn('relative', bullet?.title ? 'top-1.5' : 'top-0.5')}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="12" cy="12" r="12" fill="#D1AAD7" />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M17.3787 6.53657C17.7599 6.22599 18.3246 6.19775 18.7199 6.52246C19.1716 6.90363 19.2281 7.56716 18.8328 8.01893L11.3787 16.9695C11.2516 17.1248 11.1105 17.266 10.9411 17.3789C9.96694 18.0283 8.654 17.7601 8.00458 16.786L5.06811 12.3813C4.74341 11.9013 4.88458 11.2378 5.36458 10.913C5.73164 10.673 6.19752 10.6872 6.53635 10.913L9.62811 12.9601L17.3646 6.52246L17.3787 6.53657Z"
                                fill="black"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 24C5.37882 24 0 18.6212 0 12C0 5.37882 5.37882 0 12 0C18.6212 0 24 5.37882 24 12C24 18.6212 18.6212 24 12 24Z"
                                fill="#E5E5E5"
                              />
                            </svg>
                          </picture>
                          <div className="flex-1">
                            {bullet?.title && (
                              <h3 className="mb-2 text-2xl text-white font-aeonik">
                                {bullet?.title}
                              </h3>
                            )}
                            <p>{bullet.text}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )
            )}
            {feature.link && feature.link?.name && feature.link?.href && (
              <div className="mt-8 xl:max-h-16">
                <AnchorArrow href={feature.link.href} text={feature.link.name} />
              </div>
            )}
          </div>
        </div>
      </div>
    ))}
  </>
);

export default FeaturesVertical;
